import * as types from '../types'

const state = {
  shadeNum: 0
}

const getters = {
  shadeNum:()=>{
    return state.shadeNum;
  }
}

const actions = {

}

const mutations = {
  [types.SHADE](state,playload){
    state.shadeNum = 0;
    state.shadeNum = playload.shadeNum;
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/shade.js